module.exports = __webpack_public_path__ + "img/zbanner2-min.0eacd2b7.jpg";